import { useFormikContext } from 'formik';
import { FC } from 'react';

import Button from '@components/uiKit/Button';

import { declOfNum } from '@scripts/helpers';

import { FormValues } from '../../../../types';
import { clearFilterValue, normalizeFieldName } from '../../../../utils';
import {
    cancelButtonStyles,
    clearButtonStyles,
    desktopFooterStyles,
    desktopSubmitButtonStyles,
    mobileFooterStyles,
    mobileSubmitButtonStyles,
} from './styles';
import { FiltersFooterProps } from './types';

const FiltersFooter: FC<FiltersFooterProps> = ({
    isMobile = false,
    onClose,
    currentTotalCount,
    onApplyClick,
    fieldPrefix,
    currentRangeDefault,
    setRememberedPrice,
}) => {
    const { values, setFieldValue } = useFormikContext<FormValues>();

    const handleClear = () => {
        if (!fieldPrefix || !currentRangeDefault || !setRememberedPrice) {
            return;
        }

        Object.keys(values).forEach(key => {
            const fieldName = normalizeFieldName(key, fieldPrefix);
            clearFilterValue({
                key,
                fieldName,
                value: values[key],
                currentRangeDefault,
                setRememberedPrice,
                setFieldValue,
                updatedValues: {},
                fieldPrefix,
            });
        });
    };

    const footerStyles = isMobile ? mobileFooterStyles : desktopFooterStyles;
    const submitButtonStyles = isMobile ? mobileSubmitButtonStyles : desktopSubmitButtonStyles;

    const submitButtonText =
        currentTotalCount !== undefined
            ? `Показать ${currentTotalCount} ${declOfNum(currentTotalCount, ['товар', 'товара', 'товаров'])}`
            : 'Показать товары';

    return (
        <div css={footerStyles}>
            {!isMobile && onClose && (
                <Button size="lg" variant="reserveWhite" onClick={onClose} css={cancelButtonStyles}>
                    Отмена
                </Button>
            )}
            <Button
                variant="mainOrange"
                type="submit"
                onClick={() => {
                    onApplyClick?.();
                }}
                size="lg"
                css={submitButtonStyles}
            >
                {submitButtonText}
            </Button>
            {isMobile && (
                <Button variant="reserveWhite" onClick={handleClear} css={clearButtonStyles}>
                    Очистить
                </Button>
            )}
        </div>
    );
};

export default FiltersFooter;
